import angular from "angular";
import { GridFilter, ISubFilter } from "../gridFilter";

export interface SubFilterScope extends angular.IScope {
  subFilterController: SubFilter;
}

export abstract class SubFilter implements ISubFilter {
  displayName: string;
  readonly queryFieldNames: string[];
  protected $scope: SubFilterScope | undefined;
  protected gridFilter: GridFilter | undefined;

  constructor(config: { displayName: string; queryFieldNames: string[] }) {
    this.displayName = config.displayName;
    this.queryFieldNames = config.queryFieldNames;
  }

  init(params: { gridFilter: GridFilter }): void {
    this.gridFilter = params.gridFilter;
  }

  beforeActivate(params: { $scope: SubFilterScope }) {
    this.$scope = params.$scope;
    this.$scope.subFilterController = this;
  }

  protected getQueryFieldExpression(index: number = 0): string {
    if (this.queryFieldNames.length === 0) {
      return "";
    }

    const queryObjectExpression = this.gridFilter?.getQueryObjectExpression();
    if (queryObjectExpression === undefined) {
      throw new Error("Could not get queryObjectExpression");
    }
    const finalIndex = Math.min(
      Math.max(index, 0),
      this.queryFieldNames.length - 1
    );

    const fieldName = this.queryFieldNames[finalIndex];
    return `${queryObjectExpression}['${fieldName}']`;
  }

  abstract getGui(): angular.IAugmentedJQuery;
}
